import type { Control, Path } from 'react-hook-form'
import { useWindowDimensions, View } from 'react-native'
import { Card, Text as PaperText } from 'react-native-paper'
import { BREAKPOINTS } from '@/lib/config'
import { TextAreaInput, TextInput } from '@/ui/form'
import { AddressEdit } from '../components/AddressEdit'

interface CustomerFormFieldsProps<T extends Record<string, unknown> = Record<string, unknown>> {
    control: Control<T>
}

export function CustomerFormFields<T extends Record<string, unknown> = Record<string, unknown>>({
    control,
}: CustomerFormFieldsProps<T>) {
    const { width } = useWindowDimensions()
    const isDesktop = width >= BREAKPOINTS.lg

    return (
        <>
            <Card mode="outlined" contentStyle={{ padding: 16 }}>
                <View style={{ flexDirection: 'column' }}>
                    <PaperText variant="headlineMedium">Customer Information</PaperText>

                    <View
                        style={{
                            flexDirection: isDesktop ? 'row' : 'column',
                            gap: isDesktop ? 16 : 0,
                        }}
                    >
                        <View style={{ flex: isDesktop ? 1 : undefined }}>
                            <TextInput
                                control={control}
                                name={'name' as Path<T>}
                                label="Name *"
                                placeholder="Enter customer name"
                                autoFocus
                            />
                        </View>

                        <View style={{ width: isDesktop ? 200 : undefined }}>
                            <TextInput
                                control={control}
                                name={'identifier' as Path<T>}
                                label="Identifier *"
                                placeholder="customer-identifier"
                            />
                        </View>
                    </View>

                    <TextAreaInput
                        control={control}
                        name={'notes' as Path<T>}
                        label="Notes"
                        placeholder="Additional notes about this customer"
                        numberOfLines={3}
                    />
                </View>
            </Card>

            <Card mode="outlined" contentStyle={{ padding: 16 }}>
                <View style={{ flexDirection: 'column' }}>
                    <PaperText variant="headlineMedium">Address</PaperText>
                    <AddressEdit control={control} namePrefix="expand.address" showTitle={false} />
                </View>
            </Card>
        </>
    )
}
